<template>
  <!-- L'info-bulle est affichée par l'info-bulle personnalisée globale (common/tooltip.js) à partir de l'attribut title -->
  <span class="tooltip-container" :title="message">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'CustomTooltip',
  props: ['message']
};
</script>

<style lang="stylus" scoped>
.tooltip-container
  cursor pointer
  padding 5px
  display flex
  align-items center
  justify-content center
</style>
